/*
 * Galerie "Im Einsatz" (sections/start-galerie.liquid): Tiefe beim Scrollen.
 * Die Spalten des versetzten Rasters wandern leicht gegeneinander: die einen
 * laufen der Seite ein Stueck voraus, die anderen bleiben zurueck. Die Bewegung ist
 * AN den Scroll gebunden (kein Ausloesen, kein Nachlaufen) und schreibt nur
 * transform. Das Versetzte selbst steht in theme-build/teile/start-foto.css und
 * braucht dieses Skript nicht: ohne JavaScript und bei prefers-reduced-motion
 * steht das Raster still und sieht so gewollt aus.
 *
 * Staerke je Spalte: data-galerie-staerke am Raster, durch Leerzeichen getrennt,
 * von links nach rechts (eine Spalte weniger, ein Wert weniger). 1 ist die volle
 * Wegstrecke WEG, negativ laeuft der Seite voraus, positiv bleibt zurueck, 0
 * steht. Welche Kachel in welcher Spalte steht, liest das Skript aus ihrer Lage,
 * denn das Raster ordnet die Kacheln selbst an. Alle Kacheln einer Spalte
 * bekommen dieselbe Verschiebung in Pixeln, die Spalte wandert also als Ganzes.
 * Im Abschnitt stehen -0.7 0.7 -0.7: die aeusseren Spalten laufen voraus, die
 * mittlere bleibt zurueck, jede legt dabei hoechstens 4,2 % der Rasterhoehe
 * zurueck (WEG 6 % mal 0,7).
 *
 * Fortschritt 0, wenn die Oberkante des Rasters die Unterkante des Fensters
 * erreicht, 1, wenn seine Unterkante die Oberkante des Fensters verlaesst. Bei
 * 0,5 steht jede Spalte genau da, wo das Stylesheet sie hinsetzt. Gerechnet wird
 * nur, solange das Raster im Blick ist oder kurz davor steht; hoechstens einmal
 * je Bild (requestAnimationFrame). Im Theme-Editor bewegt sich nichts.
 */
(function () {
  'use strict';

  /* Im Theme-Editor kann die Datei erneut ausgefuehrt werden: dann nur neu einsammeln. */
  if (window.KuehnGalerie) {
    window.KuehnGalerie.start();
    return;
  }

  var WEG = 6; // Prozent der Rasterhoehe, die eine Spalte mit Staerke 1 vom Eintritt bis zum Austritt zuruecklegt
  var PASSIV = { passive: true };
  /* Ein Viertel Fenster Vorlauf: der Stand stimmt, bevor das Raster zu sehen ist. */
  var VORLAUF = { rootMargin: '25% 0px' };

  var wenigBewegung = window.matchMedia('(prefers-reduced-motion: reduce)');
  var imEditor = window.Shopify && window.Shopify.designMode;
  var instanzen = [];

  function einrichten(raster) {
    var staerken = (raster.getAttribute('data-galerie-staerke') || '')
      .split(/\s+/)
      .filter(Boolean)
      .map(parseFloat);
    var kacheln = []; // { el: Huelle der Bewegung, faktor: Staerke seiner Spalte }
    var beobachter = null;
    var laeuft = false;
    var horcht = false;
    var bildId = 0;
    var stand = null; // zuletzt gezeichneter Fortschritt

    /* Spalte jeder Kachel aus ihrer Lage im Raster; die Rasterzelle selbst bewegt sich nicht. */
    function messen() {
      var huellen = raster.querySelectorAll('[data-galerie-tiefe]');
      var rasterBox = raster.getBoundingClientRect();
      var luecke = parseFloat(window.getComputedStyle(raster).columnGap) || 0;
      kacheln = [];
      for (var i = 0; i < huellen.length; i++) {
        var zelle = huellen[i].parentNode.getBoundingClientRect();
        var spalte = zelle.width > 0 ? Math.round((zelle.left - rasterBox.left) / (zelle.width + luecke)) : 0;
        var faktor = staerken[spalte];
        kacheln.push({ el: huellen[i], faktor: isNaN(faktor) ? 0 : faktor });
      }
      stand = null;
    }

    function zeichnen() {
      // lesen
      var box = raster.getBoundingClientRect();
      var fenster = document.documentElement.clientHeight;
      var weg = fenster + box.height;
      var p = weg > 0 ? Math.min(1, Math.max(0, (fenster - box.top) / weg)) : 0;
      if (p === stand) return;
      stand = p;
      var pixel = (p - 0.5) * (WEG / 100) * box.height;
      // schreiben
      for (var i = 0; i < kacheln.length; i++) {
        var k = kacheln[i];
        k.el.style.transform = k.faktor ? 'translate3d(0,' + (pixel * k.faktor).toFixed(2) + 'px,0)' : '';
      }
    }

    function planen() {
      if (bildId || !laeuft) return;
      bildId = window.requestAnimationFrame(function () {
        bildId = 0;
        zeichnen();
      });
    }

    function beiGroesse() {
      messen();
      planen();
    }

    function horchen(ein) {
      if (ein === horcht) return;
      horcht = ein;
      var methode = ein ? 'addEventListener' : 'removeEventListener';
      window[methode]('scroll', planen, PASSIV);
      window[methode]('resize', beiGroesse, PASSIV);
      // Eigene Ebene nur in Reichweite: die Verschiebung kostet dann kein Neuzeichnen der Fotos.
      for (var i = 0; i < kacheln.length; i++) kacheln[i].el.style.willChange = ein ? 'transform' : '';
    }

    function an() {
      if (laeuft || wenigBewegung.matches || imEditor || !staerken.length) return;
      laeuft = true;
      messen();
      if ('IntersectionObserver' in window) {
        beobachter = new IntersectionObserver(function (eintraege) {
          var nah = eintraege[eintraege.length - 1].isIntersecting;
          // Kommt das Raster in Reichweite (auch nach einem Sprung ueber es hinweg), gilt der
          // Stand sofort; beim Verlassen steht der Fortschritt fest auf 0 oder 1.
          if (nah) messen();
          horchen(nah);
          if (nah) zeichnen();
          else planen();
        }, VORLAUF);
        beobachter.observe(raster);
      } else {
        horchen(true);
        zeichnen();
      }
    }

    /* Zurueck zum ruhenden Raster. */
    function aus() {
      if (!laeuft) return;
      laeuft = false;
      if (beobachter) {
        beobachter.disconnect();
        beobachter = null;
      }
      horchen(false);
      if (bildId) {
        window.cancelAnimationFrame(bildId);
        bildId = 0;
      }
      for (var i = 0; i < kacheln.length; i++) kacheln[i].el.style.transform = '';
      stand = null;
    }

    return { wurzel: raster, an: an, aus: aus };
  }

  /* Sammelt alle Raster im Bereich ein (ohne Angabe: im ganzen Dokument). */
  function start(bereich) {
    instanzen = instanzen.filter(function (instanz) {
      if (document.documentElement.contains(instanz.wurzel)) return true;
      instanz.aus();
      return false;
    });
    var wurzeln = (bereich && bereich.querySelectorAll ? bereich : document).querySelectorAll('[data-galerie]');
    Array.prototype.forEach.call(wurzeln, function (raster) {
      for (var i = 0; i < instanzen.length; i++) {
        if (instanzen[i].wurzel === raster) return;
      }
      var instanz = einrichten(raster);
      instanzen.push(instanz);
      instanz.an();
    });
  }

  function beenden(bereich) {
    instanzen = instanzen.filter(function (instanz) {
      if (bereich && !bereich.contains(instanz.wurzel)) return true;
      instanz.aus();
      return false;
    });
  }

  function bewegungGeaendert() {
    instanzen.forEach(function (instanz) {
      if (wenigBewegung.matches) instanz.aus();
      else instanz.an();
    });
  }
  if (wenigBewegung.addEventListener) wenigBewegung.addEventListener('change', bewegungGeaendert);
  else if (wenigBewegung.addListener) wenigBewegung.addListener(bewegungGeaendert);

  /* Theme-Editor: Abschnitt neu aufbauen bzw. hinter ihm aufraeumen */
  document.addEventListener('shopify:section:load', function (e) {
    start(e.target);
  });
  document.addEventListener('shopify:section:unload', function (e) {
    beenden(e.target);
  });

  window.KuehnGalerie = { start: start, beenden: beenden };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      start();
    });
  } else {
    start();
  }
})();
